import PropTypes from 'prop-types';

import { theme } from '@prose-ui';
import { useStyles, withStyles } from 'legacyStyles';

import { range } from '../utils/range';

const styles = {
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '50px',
  },
  noFixedHeight: {
    height: '6px',
  },
  absolute: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 40,
  },
  bullet: {
    appearance: 'none',
    backgroundColor: 'transparent',
    border: 'none',
    borderRadius: '100px',
    height: 6,
    marginRight: 6,
    padding: 0,
    opacity: '.5',
    '&.active': {
      opacity: '1',
    },
    '&:last-child': {
      marginRight: 0,
    },
    width: 6,
  },
  white: {
    background: theme.colors.neutral[100],
  },
  noir: {
    background: theme.colors.primary[400],
    '&.active': {
      background: theme.colors.neutral[900],
    },
  },
  rectangleWhite: {
    width: 36,
    height: 3,
    borderRadius: 0,
    background: theme.colors.neutral[100],
    position: 'relative',
    '&.active': {
      opacity: 1,
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  rectangleBlack: {
    width: 36,
    height: 3,
    borderRadius: 0,
    background: theme.colors.neutral[900],
    position: 'relative',
    '&.active': {
      opacity: 1,
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  background: {
    whiteSpace: 'nowrap',
    '&.white': {
      height: '22px',
      borderRadius: '100px',
      background: theme.colors.neutral['100'],
      padding: '0 5px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
};

const SliderControls = ({
  size,
  classes,
  currentIndex,
  theme: variant,
  position,
  onClick,
  arrowLeft,
  arrowRight,
  dataFrom,
  withBackground,
  noFixedHeight,
}) => {
  const controlsArray = range(size);
  const { cx } = useStyles();
  return (
    <div
      className={cx(classes.root, classes[position], noFixedHeight ? classes.noFixedHeight : null)}
    >
      {arrowLeft}
      <div className={cx(classes.background, { white: withBackground })}>
        {controlsArray.map(index => (
          <button
            key={index}
            aria-label={`Switch to slide ${index + 1}`}
            className={cx(classes.bullet, classes[variant], {
              active: index === currentIndex,
            })}
            data-click="change-slide-dot"
            data-from={dataFrom}
            data-testid="slider-control"
            onClick={event => {
              event.stopPropagation();
              onClick(index);
            }}
            type="button"
          />
        ))}
      </div>
      {arrowRight}
    </div>
  );
};

SliderControls.defaultProps = {
  theme: 'white',
  position: null,
  arrowLeft: null,
  arrowRight: null,
  dataFrom: null,
  withBackground: false,
  noFixedHeight: false,
};

SliderControls.propTypes = {
  size: PropTypes.number,
  position: PropTypes.oneOf(['absolute']),
  classes: PropTypes.object,
  currentIndex: PropTypes.number,
  onClick: PropTypes.func.isRequired,
  theme: PropTypes.oneOf(['white', 'noir', 'rectangleWhite', 'rectangleBlack']),
  arrowLeft: PropTypes.node,
  arrowRight: PropTypes.node,
  dataFrom: PropTypes.string,
  withBackground: PropTypes.bool,
  noFixedHeight: PropTypes.bool,
};

export default withStyles(SliderControls, styles);
